var map = {
	"./cart-empty-error.svg": "8c38",
	"./cart-empty.svg": "bff3",
	"./delete.svg": "99a1",
	"./equal.svg": "5574",
	"./exclamation-mark-red.svg": "6275",
	"./minus.svg": "b616",
	"./plus.svg": "27bd",
	"./shiny-card.svg": "e1d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6447";